import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import FullPageDocumentDropComponent from "../FullPageDocumentDropComponent";
import constants from "../constants";
import documentTypes from "../documentTypes";
import operations from "../ducks/operations";
import DocumentDrop from "./DocumentDropComponentBeta";

const DocumentDropContainer = (props) => {
    const {
        elementsSaving,
        entityKey,
        formDisabled,
        getDocumentRequirementsByParentEntityType,
        getDocuments,
        isBrokerAndClosedVoucher,
        options,
        parentType,
        type,
    } = props;

    useEffect(() => {
        if (entityKey) {
            if (parentType) {
                getDocumentRequirementsByParentEntityType(parentType, entityKey);
            }
            getDocuments(entityKey, type);
        }
    }, [entityKey, parentType, type, getDocumentRequirementsByParentEntityType, getDocuments]);

    const disableUploads = isBrokerAndClosedVoucher
        ? true
        : (options?.canUpload ?? []).length > 0
        ? false
        : formDisabled;

    return (
        <div data-testid="documentDropContainer">
            {elementsSaving.getDocumentRequirements ? (
                <div className="circularProgressCentered">
                    <CircularProgress />
                </div>
            ) : (
                <React.Fragment>
                    <DocumentDrop
                        {...props}
                        disableUploads={disableUploads}
                        documentTypes={documentTypes[props.documentTypes]}
                        allDocumentTypes={documentTypes["all"]}
                    />
                    <FullPageDocumentDropComponent {...props} disableUploads={disableUploads} />
                </React.Fragment>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        snackbarOpen: state.authReducer.snackbarOpen,
        columnToSort: state.documentsReducer.documentColumnToSort,
        sortDirection: state.documentsReducer.documentSortDirection,
        used: state.documentsReducer.documentTypes,
        usedDocTypes: state.documentsReducer.usedDocTypes,
        savedDocuments: state.documentsReducer.savedDocuments,
        missingRequiredDocuments: state.documentsReducer.missingRequiredDocuments,
        anchorEl: state.documentsReducer.anchorEl,
        docKey: state.documentsReducer.docKey,
        loading: state.documentsReducer.loading,
        documentsUploading: state.documentsReducer.documentsUploading,
        elementsSaving: state.utilsReducer.elementsSaving,
        documentRequirements: state.documentsReducer.documentRequirements,
        parentEntityTypeKey: state.documentsReducer.parentEntityTypeKey,
        requiredDocs: state.documentsReducer.requiredDocs,
        optionalDocs: state.documentsReducer.optionalDocs,
        documentTypesForParentEntity: state.documentsReducer.documentTypesForParentEntity,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideSnackbar: () => {
            dispatch(operations.hideSnackbar());
        },
        handleDocumentSort: (columnName) => {
            dispatch(operations.handleDocumentSort(columnName));
        },
        handleRejectedDocs: (rejected) => {
            dispatch(operations.handleRejectedDocs(rejected));
        },
        handleOpenDocumentMenu: (key, anchorEl) => {
            dispatch(operations.handleOpenDocumentMenu(key, anchorEl));
        },
        handleMenuClose: () => {
            dispatch(operations.handleMenuClose());
        },
        handleSort: (columnName) => {
            dispatch(operations.handleDocumentSort(columnName));
        },
        viewDocument: (url, key) => {
            dispatch(operations.viewDocument(url, key));
        },
        downloadDocument: (document) => {
            dispatch(operations.downloadDocument(document));
        },
        addDocuments: (key, type, documents, ownerType) => {
            dispatch(operations.addDocument(constants.urls.add_document(key, type), documents, ownerType));
        },
        removeDocument: (key) => {
            dispatch(operations.removeDocument(constants.urls.remove_document(key), key));
        },
        approveDocument: (key) => {
            dispatch(operations.approveDocument(constants.urls.approve_document(key), key));
        },
        updateDocument: (key, mediaAssetType) => {
            dispatch(operations.updateDocument(constants.urls.update_document(key), key, mediaAssetType));
        },
        getDocuments: (key, type) => {
            dispatch(operations.getDocuments(constants.urls.get_documents(key, type)));
        },
        copyDocUrl: (key) => {
            dispatch(operations.copyDocUrl(key));
        },
        toggleTerminationDoc: (attached) => {
            dispatch(operations.toggleTerminationDoc(attached));
        },
        updateDocumentFromAdminList: (key, mediaAssetType, parentEntityTypeKey, documentTypeKey, documentDao) => {
            dispatch(
                operations.updateDocumentFromAdminList(
                    constants.urls.update_document(key),
                    key,
                    mediaAssetType,
                    parentEntityTypeKey,
                    documentTypeKey,
                    documentDao
                )
            );
        },
        getDocumentRequirementsByParentEntityType: (parentEntityTypeName, parentKey) => {
            dispatch(operations.getDocumentRequirementsByParentEntityType(parentEntityTypeName, parentKey));
        },
        setAdminDocumentTypeListAvailable: () => {
            dispatch(operations.setAdminDocumentTypeListAvailable());
        },
        resetRequiredMissingDocuments: () => {
            dispatch(operations.resetRequiredMissingDocuments());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentDropContainer);
